import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import AutoComp from '../components/AutoComp'
import FrDatePicker from '../components/FrDatePicker'


import api from '../services/api'
import { dateSql, paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty, getSedeCode, getUserCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Cobranca(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [cli, setCli] = useState()
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [comboTipo, setComboTipo] = useState([{ value: " and cob.tipo='30dd'", display: 'Vencimento no mês' },
  { value: " and cob.tipo='60dd'", display: 'Vencimento do mês anterior' },
  { value: " and cob.tipo='90dd'", display: 'Vencimento além do mês anterior' }
  ])

  const [comboSed, setComboSed] = useState([{ value: '', display: '' }])
  const [comboSituacao, setComboSituacao] = useState([{ value: " and coalesce(cob.valor_pago,0)=0", display: 'Pendentes' },
  { value: " and coalesce(cob.valor_pago,0)>0", display: 'Pagos' }
  ])

  const columns = [
    { id: 'mes_ano', date: true, numeric: false, label: 'Dt.Geração', align: 'left', minWidth: 20 },
    { id: 'pk_cto', numeric: true, label: 'Nº Contrato', align: 'left', minWidth: 20, isLink: true, linkTo: 'contratos', searchValue: 'pk_cto' },
    { id: 'nomecli', numeric: false, label: 'Titular', align: 'left', minWidth: 200, isLink: true, linkTo: 'clientes', searchValue: 'pk_cli' },
    { id: 'nomefpg', numeric: false, label: 'Forma de Pgto', align: 'left', minWidth: 150 },
    { id: 'fone1', numeric: false, label: 'Fone 1', align: 'left', minWidth: 130 },
    { id: 'fone2', numeric: false, label: 'Fone 2', align: 'left', minWidth: 130 },
    { id: 'dependentes', numeric: false, label: 'Qtde Deps', align: 'left', minWidth: 10 },
    { id: 'data_venc', date: true, numeric: false, label: 'Vcto', align: 'left', minWidth: 20 },
    { id: 'format_valor', numeric: true, label: 'Valor', align: 'right', minWidth: 20 },
    { id: 'format_pago', numeric: true, label: 'Valor Pago', align: 'right', minWidth: 20 },
    { id: 'tipo', numeric: true, label: 'Tipo', align: 'right', minWidth: 10 },

  ]
  const [texto, setTexto] = useState('')

  const [soma30, setSoma30] = useState('0,00')
  const [saldo30, setSaldo30] = useState('0,00')
  const [pago30, setPago30] = useState('0,00')

  const [soma60, setSoma60] = useState('0,00')
  const [saldo60, setSaldo60] = useState('0,00')
  const [pago60, setPago60] = useState('0,00')

  const [soma90, setSoma90] = useState('0,00')
  const [saldo90, setSaldo90] = useState('0,00')
  const [pago90, setPago90] = useState('0,00')

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      let tela = 'Cobrança'
      setenableAdd(await api.getAcessos(tela, 'Inclusao'))
      setComboFpg(await api.getComboData('formas_pagamento'))
      setComboSed(await api.getComboDataWhere('sedes', "?fk_usu=" + getUserCode()))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      if (query.fk_cli)
        setCli(query.fk_cli)

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    if (!isEmpty(queryObject)) {
      queryObject.buscar = true
      queryObject.pk_sed = getSedeCode()

      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/salute/cobranca?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/cobranca', { params: queryObject }).then(r => {
        if (r.data[0]) {
          setSoma30(r.data[0].soma30)
          setSaldo30(r.data[0].saldo30)
          setPago30(r.data[0].pago30)

          setSoma60(r.data[0].soma60)
          setSaldo60(r.data[0].saldo60)
          setPago60(r.data[0].pago60)

          setSoma90(r.data[0].soma90)
          setSaldo90(r.data[0].saldo90)
          setPago90(r.data[0].pago90)

        } else {
          setSoma30('0,00')
          setSaldo30('0,00')
          setPago30('0,00')

          setSoma60('0,00')
          setSaldo60('0,00')
          setPago60('0,00')

          setSoma90('0,00')
          setSaldo90('0,00')
          setPago90('0,00')

        }
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire({
        title: 'Nenhum filtro informado!',
        html: '<p>Informe ao menos um filtro para realizar a busca.',
        icon: 'warning'
      })

    }
  }

  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/cobranca');
    document.getElementById('searchForm').reset()
    setCli('')
    setFilter({})
  }

  async function geraRegistros(e) {
    e.preventDefault();

    const { value: formValues } = await swal.fire({
      title: "Geração de Lote de Cobrança",
      html: (
        <div>
          <br />
          <FrDatePicker
            name="data"
            id="data"
            color="#083c7c"
            label="Competência para geração"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
            autoFocus
          />
        </div>
      ),
      focusConfirm: false,
      preConfirm: () => {
        return {
          data: document.getElementById("data").value,
        };
      },
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "OK",
      confirmButtonColor: `#083c7c`,
      allowOutsideClick: false,
    });

    if (formValues && formValues["data"]) {
      let data = formValues["data"]
      let auxData = new Date(data)
      api.get("/cobranca?data=" + data).then(async r => {
        if (r.data.length > 0)
          swal.fire({
            title: 'Competência já gerada!',
            html: 'Já existem registros gerados para esta competência!',
            icon: 'warning'
          })
        else {
          setTexto('Aguarde...buscando registros a gerar...')
          await api.get("/cobranca/pegaRegistros?competencia=" + data).then(async r => {
            let contador = Number(r.data.length)
            for (let index = 0; index < r.data.length; index++) {
              setTexto('Gerando ' + (Number(index) + 1) + ' de ' + contador + '...')
              const element = r.data[index];
              await api.post("/cobranca/geraRegistros?competencia=" + data + '&data_venc=' + dateSql(element.data_venc)).then(r => {

                if ((Number(index) + 1) == contador) {
                  swal.fire('Cobrança Gerada', 'Cobrança gerada com sucesso!', 'success');
                  const auxValues = { ...filter };
                  auxValues.dataini = data
                  auxValues.datafim = data
                  setFilter(auxValues);

                  let event = new Event('build');
                  getData(event)

                  setTexto('')
                }
              })

            }
          })
        }
      })
    }
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'fk_cli':
        setCli(e.target.value);
      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };


  useEffect(() => {
    const fetchCli = async () => {
      const auxValues = { ...filter };
      auxValues["fk_cli"] = cli;
      auxValues["nomecli"] = ''
      if (cli > 0) {
        await api.get("/clientes?pk_cli=" + cli).then((r) => {
          if (r.data[0]) {
            auxValues["nomecli"] = r.data[0].nome;

          }
        });
      }
      setFilter(auxValues);
    };
    fetchCli();
  }, [cli]);


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Cobrança</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>

              <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período Geração"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
                autoFocus
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                name="datafim"
                id="datafim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.tipo || -1}
                style={{ width: 250 }}
                name="tipo"
                id="tipo"
                label='Tipo'
                data={comboTipo}
                onChange={handleChange}
                mostraTodos
              />

              <AutoComp
                value={filter.nomecli || ""}
                valor={cli}
                width={400}
                tabela={'clientes'}
                chave={'nome'}
                name="fk_cli"
                id="fk_cli"
                label='Titular'
                data={comboCli}
                setValue={setCli}
                form={'searchForm'}
                manut={'cobranca'}

              />

              <br />
              <FrTextInput
                value={filter.pk_cto || ''}
                style={{ width: 100 }}
                name="pk_cto"
                id="pk_cto"
                color="#333333"
                label="Nº Contrato"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <FrSelect
                value={filter.fk_fpg || -1}
                style={{ width: 250 }}
                name="fk_fpg"
                id="fk_fpg"
                label='Forma de Pagamento'
                data={comboFpg}
                onChange={handleChange}
                mostraTodos
              />

              <FrSelect
                value={filter.fk_sed || -1}
                style={{ width: 150 }}
                name="fk_sed"
                id="fk_sed"
                label='Sede'
                data={comboSed}
                onChange={handleChange}
                mostraTodos
              />

              <FrSelect
                value={filter.situacao || -1}
                style={{ width: 150 }}
                name="situacao"
                id="situacao"
                label='Situação'
                data={comboSituacao}
                onChange={handleChange}
                mostraTodos
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <button onClick={geraRegistros}>
                  <Icon icon={ic_add_box} size={18} />
                  Gerar Lote
                </button>
              }

            </div>
          </form>
        </div>
        <br />
        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable historicos={true} readOnly={true} startOrderBy={'data_venc'} mostraCheck={'N'} width={50} regName="cobranca" columns={columns} searched={filtered} codeName="fk_cto" page={'cobranca'} data={data} enableEdit={enableEdit} enableDel={enableDel} />
          {texto ?
            <FrLoading text={texto} />
            : <></>}

        </div>

        <div hidden={!data[0]}>
          {/* <div class="row" >
            <div class="column" ><label style={{ paddingLeft: '50px', paddingRight: '10px' }}></label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large', alignSelf: 'end' }}>Total</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large', alignSelf: 'end' }}>Pago</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large', alignSelf: 'end' }}>Pendente</label></div>
          </div>


          <div class="row">
            <div class="column" ><label style={{ paddingLeft: '10px', paddingRight: '10px', fontWeight: 'bold', fontSize: 'large' }}>30dd</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', fontSize: 'large' }}> {soma30}</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large', alignSelf: 'end' }}> {pago30}</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large', alignSelf: 'end' }}> {saldo30}</label></div>
          </div>

          <div class="row">
            <div class="column"><label style={{ paddingLeft: '10px', paddingRight: '10px', fontWeight: 'bold', fontSize: 'large' }}>60dd</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large' }}> {soma60}</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large' }}> {pago60}</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large' }}> {saldo60}</label></div>
          </div>

          <div class="row" >
            <div class="column" ><label style={{ paddingLeft: '10px', paddingRight: '10px', fontWeight: 'bold', fontSize: 'large' }}>90dd</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large', alignSelf: 'flex-end' }}> {soma90}</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large', alignSelf: 'end' }}> {pago90}</label></div>
            <div class="column" className='colunaResumo'><label style={{ paddingLeft: '10px', paddingRight: '30px', fontWeight: 'bold', width: '100px', fontSize: 'large', alignSelf: 'end' }}> {saldo90}</label></div>
          </div> */}

          <table className='tabelaResumo'>
            <tr>
              <th className='colunaResumo' />
              <th className='colunaResumo'><label>Total</label></th>
              <th className='colunaResumo'><label>Pago</label></th>
              <th className='colunaResumo'><label>Pendente</label></th>
            </tr>
            <tr>
              <td className='colunaResumo'><label>30dd</label></td>
              <td className='colunaResumo'><label>{soma30}</label></td>
              <td className='colunaResumo'><label>{pago30}</label></td>
              <td className='colunaResumo'><label>{saldo30}</label></td>
            </tr>
            <tr>
              <td className='colunaResumo'><label>60dd</label></td>
              <td className='colunaResumo'><label>{soma60}</label></td>
              <td className='colunaResumo'><label>{pago60}</label></td>
              <td className='colunaResumo'><label>{saldo60}</label></td>
            </tr>
            <tr>
              <td className='colunaResumo'><label>90dd</label></td>
              <td className='colunaResumo'><label>{soma90}</label></td>
              <td className='colunaResumo'><label>{pago90}</label></td>
              <td className='colunaResumo'><label>{saldo90}</label></td>
            </tr>

          </table>

        </div>

        <FooterDelphus />
      </div>
    </div>
  );
}

export default Cobranca;